(function($) {
  'use strict';

  const RevotyStickyAtc = {
    bar: null,
    $form: null,
    $formQty: null,
    successTimer: null,

    init: function() {
      this.bar = document.querySelector('.revoty-sticky-atc');
      this.$form = $('form.cart').first();

      if (!this.bar || !this.$form.length) {
        return;
      }

      this.$formQty = this.$form.find('input.qty').first();

      this.bindVisibility();
      this.bindQuantity();
      this.bindButton();
      this.bindCartEvents();
    },

    bindVisibility: function() {
      // Show the bar once the product form scrolls out of view
      const formEl = this.$form.get(0);

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            this.toggleBar(!entry.isIntersecting && entry.boundingClientRect.top < 0);
          });
        }, { threshold: 0 });

        observer.observe(formEl);
      } else {
        $(window).on('scroll.revotyStickyAtc', () => {
          const rect = formEl.getBoundingClientRect();
          this.toggleBar(rect.bottom < 0);
        });
      }
    },

    toggleBar: function(visible) {
      this.bar.classList.toggle('revoty-sticky-atc--visible', visible);
      this.bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
    },

    bindQuantity: function() {
      const input = this.bar.querySelector('.revoty-sticky-atc__qty-input');

      if (!input) {
        return;
      }

      this.bar.querySelectorAll('.revoty-sticky-atc__qty-btn').forEach((btn) => {
        btn.addEventListener('click', () => {
          const step = btn.classList.contains('revoty-sticky-atc__qty-btn--plus') ? 1 : -1;
          const min = parseInt(input.min, 10) || 1;
          const max = parseInt(input.max, 10) || Infinity;
          const value = (parseInt(input.value, 10) || min) + step;

          input.value = Math.min(max, Math.max(min, value));
          this.syncFormQuantity(input.value);
        });
      });

      input.addEventListener('change', () => {
        this.syncFormQuantity(input.value);
      });

      // Keep the bar in sync when the form quantity changes
      if (this.$formQty.length) {
        this.$formQty.on('change input', (event) => {
          input.value = event.currentTarget.value;
        });
      }
    },

    syncFormQuantity: function(value) {
      if (this.$formQty.length) {
        this.$formQty.val(value).trigger('change');
      }
    },

    bindButton: function() {
      const button = this.bar.querySelector('.revoty-sticky-atc__button');
      const isSimple = this.bar.dataset.productType === 'simple';

      button.addEventListener('click', () => {
        if (isSimple) {
          // Delegate to the real button so AJAX add-to-cart themes keep working
          this.$form.find('.single_add_to_cart_button').first().trigger('click');
        } else {
          // Variable, grouped, and external products need the full form
          this.$form.get(0).scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    },

    bindCartEvents: function() {
      $(document.body).on('added_to_cart', () => {
        const button = this.bar.querySelector('.revoty-sticky-atc__button');

        button.classList.add('revoty-sticky-atc__button--success');
        clearTimeout(this.successTimer);
        this.successTimer = setTimeout(() => {
          button.classList.remove('revoty-sticky-atc__button--success');
        }, 2000);
      });
    }
  };

  $(document).ready(function() {
    RevotyStickyAtc.init();
  });
})(jQuery);
